import { string, object } from "yup";
import type { AnyObjectSchema } from "yup";

import type { ValidatedTextField, ValidatedPasswordField } from "../connector-content/interface";

export const getYupSchema = (
  fields: Array<ValidatedTextField | ValidatedPasswordField>
): AnyObjectSchema | undefined => {
  const validation = {};

  for (const field of fields) {
    if (!field.rules || !field.rules.length) {
      continue;
    }

    const { rules, name } = field;
    const { required, message } = rules[0];
    const pattern = rules.length === 1 ? rules[0].pattern : undefined;

    let fieldValidation = string();
    if (required) {
      fieldValidation = fieldValidation.required(message);
    }

    if (pattern) {
      fieldValidation = fieldValidation.matches(pattern, message);
    }

    if (rules[1]) {
      const { min, max, message } = rules[1];
      fieldValidation = fieldValidation.min(min, message);
      fieldValidation = fieldValidation.max(max, message);
    }

    validation[name] = fieldValidation;
  }

  if (!Object.keys(validation).length) {
    return;
  }

  return object(validation);
};
